import { z } from 'zod';
import Config from '../../config';
import authEndpoints from './authEndpoints';
import clientErrorSchema from '../response-schema/clientErrorSchema';
import apiClient from '../apiClient';

// Define the type for the response data
type InitAuthResponse = z.infer<typeof clientErrorSchema>;

export const initAuth = async ({
  email,
}: {
  email: string;
}): Promise<InitAuthResponse | Error> => {
  const { API_URL } = Config;
  const response = await apiClient.post(
    `${API_URL}${authEndpoints.InitAuthEndpoint}`,
    {
      email,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return response;
};
